import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const blacklistApi = createApi({
  reducerPath: "blacklistApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
    // baseQuery: dynamicBaseQuery,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    addBlackListNumber: builder.mutation({
      query: (data) => ({
        url: "/blacklist/addblacklistnumbers",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    deleteBlackListNumber: builder.mutation({
      query: (data) => ({
        url: "/blacklist/deleteblacklistnumbers",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    searchBlackListNumber: builder.query({
      query: (phoneNumber) => ({
        url: "/blacklist/blacklist/search",
        method: "GET",
        params: { phone_number: phoneNumber },
      }),
    }),
    getCustomerCountries: builder.query({
      query: () => "/blacklist/customer-country",
      providesTags: ["User"],
    }),
  }),
});

export const {
  useAddBlackListNumberMutation,
  useSearchBlackListNumberQuery,
  useGetCustomerCountriesQuery,
  useLazySearchBlackListNumberQuery,
  useDeleteBlackListNumberMutation,
} = blacklistApi;
